import { render, staticRenderFns } from "./DashboardExciseLiability.vue?vue&type=template&id=1247f87c&"
import script from "./DashboardExciseLiability.vue?vue&type=script&lang=js&"
export * from "./DashboardExciseLiability.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports